export const portfolioCharts = {
    xSelect1: 'Score (Technological Progress)',
    ySelect1: 'Market Expectation',
    yAxisUnit: 'bn yen',
    labelArrayOverFlowMsg: 'Up to five labels can be displayed.'
}
